import { DocumentationPageApprovalState } from "@supernova-studio/model";
import { z } from "zod";
export const DTODocumentationPageApprovalState = z.object({
    approvalState: DocumentationPageApprovalState,
    pagePersistentId: z.string(),
    updatedByUserId: z.string(),
    designSystemVersionId: z.string(),
    updatedAt: z.coerce.date(),
    createdAt: z.coerce.date(),
});
export const DTODocumentationGroupApprovalState = z.object({
    persistentId: z.string(),
    groupPersistentId: z.string(),
    designSystemVersionId: z.string(),
    approvalState: DocumentationPageApprovalState,
});
